export default __webpack_public_path__ + "static/media/img13.bd3a84e1.png";